module.exports = __webpack_public_path__ + "static/media/cardback.34a7b128.svg";